<template>
  <div>
    <div class="my-swiper-wrap">
      <div class="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in newsData">
            
            <a :href="item.swiper.link" target="_blank">
              <img class="url" :src="item.swiper.url" alt="">
              <div class="description">{{ item.swiper.description }}</div>
            </a>
            
            
            <div class="d-wrap">
              <img class="smallUrl" :src="item.swiper.smallUrl" alt="">
              <span class="title">{{ item.swiper.title }}</span>
              <!-- <span class="gang">  </span>
              <span class="label">{{ item.swiper.label }}</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="my-swiper-btn-wrap ">
      <div class="swiper-button-prev"></div>  
      <div class="mySwiperBtn ">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in newsData">
            <img class="url" :src="item.btn.url" alt="">
            <div class="description">{{ item.btn.description }}</div>
          </div>
        </div>
      </div>
      <div class="swiper-button-next"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';

// import 'swiper/swiper-bundle.css'
import 'swiper/css/swiper.css';  //swiper@5.4.5

export default {
  components: {
  },
  props: ['newsData']
  ,
  data() {
    return {
      
    }
  },
  mounted() {
    const swiper = new Swiper(".mySwiperBtn", {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    }); 

    const swiper2 = new Swiper(".mySwiper", {
      spaceBetween: 10,
      navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: swiper,
      },
    });
  },
  methods: {
    
  }
};
  
</script>

<style lang="scss" scoped>
img{
  object-fit: cover;
}
.my-swiper-wrap{
  background: url('~@/assets/newProductAppleFall/swiper-bg.png') center center no-repeat;
  background-size: 100%;
  margin: 0 auto;
  width: 1080px;
  height: 599px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mySwiper{
  width: 866px;
  height: 488px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  background-color: #fff;
  .swiper-wrapper{
    background-color: #fff;
    width: 100%;
    height: 100%;
  }
  .swiper-slide{
    background-color: #fff;
    width: 100%;
    height: 100%;
    .url{
      width:100%;
      object-fit: cover;
      height: 400px;
    }
    
    .description{
      font-family: PingFangSC-Medium, PingFang SC;
      padding-top: 10px;
      padding-left: 20px;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
    .d-wrap{
      padding-top: 17px;
      padding-left: 20px;
      display: flex;
      align-items: center;
      
    }
    .smallUrl{
      // opacity: 0;
      width:26px;
      height: 26px;
      border-radius: 50%;
    }
    .title{
      font-family: PingFangSC-Regular, PingFang SC;
      padding: 0 0 0 5px;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
    }
    .gang{
      margin: 0 10px;
      width: 1px;
      height: 9px;
      background: #D8D8D8;
    }
    .label{
      font-size: 12px;
      font-weight: bold;
      color: #23CDE1;
      line-height: 17px;
    }
  }
}
.my-swiper-btn-wrap{
  .swiper-button-prev{
    position: relative;
    width: 46px;
    height: 46px;
    background: url('~@/assets/newProductAppleFall/btn-pre.png') no-repeat;
    background-size: 100%;
  }
  .swiper-button-next{
    position: relative;
    width: 46px;
    height: 46px;
    background: url('~@/assets/newProductAppleFall/btn-next.png') no-repeat;
    background-size: 100%;
  }
  .swiper-button-prev:after, .swiper-button-next:after{
     content: '' 
    }
  display: flex;
  justify-content: space-around;
  align-items: center;
  .btn-pre, .btn-next{
    img{
      width: 44px;
      height: 44px;
    }
  }
  .mySwiperBtn{
    margin: 29px 0;
    width: 866px;
    height: 164px;
    overflow: hidden;
    box-sizing: border-box;
    .swiper-wrapper{
      width: 100%;
    }
    .swiper-slide {
      width: 199px;
      height: 164px;
      border-radius: 3px;
      border: 1px solid #F2F2F2;
      opacity: 0.4;
      
      img{
        object-fit: cover;
        width: 100%;
        height: 123px;
      }
      .description{
        font-family: PingFangSC-Medium, PingFang SC;
        padding: 5px 10px;
        font-size: 12px;
        font-weight: 500;
        color: #333333;
        line-height: 17px;

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        word-break: break-all;
        -webkit-box-orient: vertical;

      }
    }
    .swiper-slide-thumb-active {
      opacity: 1;
    }
  }
}
</style>
